export default __webpack_public_path__ + "static/media/step_2_do.c703b6d2.jpg";